module.exports = __webpack_public_path__ + "img/white-btn.d2d31155.svg";